enum RoutingPhase {
    Base = "base",
    Transit = "transit",
}

export default RoutingPhase;
